<template>
	<v-card flat class="mt-2">
		<!-- Snackbar -->
		<Snackbar
			@close-snackbar="snackbar.status = false"
			v-model="snackbar.status"
			:text="snackbar.text"
			:color="snackbar.color"
			:timeout="snackbar.timeout"
		/>

		<v-row>
			<!-- Country -->
			<v-col>
				<v-select
					chips
					clearable
					deletable-chips
					small-chips
					dense
					filled
					multiple
					label="Country"
					:loading="isLoading.countries"
					:items="countries"
					v-model="selected.countries"
					return-object
					@change="handleOnChange('countries')"
					hide-details
					class="c-input"
					:disabled="isLoading.search"
					:menu-props="menuProps"
				/>
			</v-col>

			<!-- ATC Code -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					deletable-chips
					small-chips
					dense
					filled
					multiple
					label="ATC Code"
					:items="atcCodes"
					v-model="selected.atcCodes"
					:loading="isLoading.atcCodes"
					:search-input.sync="search.atcCodes"
					hide-no-data
					hide-selected
					return-object
					@keydown.enter="selectOnEnter('atcCodes', $event)"
					ref="atcCodes"
					hide-details
					cache-items
					class="c-input"
					@change="handleAtcCodes"
					:disabled="isLoading.search"
					@input="search.atcCodes = null"
				/>
			</v-col>

			<!-- Formulation -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Formulation"
					:items="formulations"
					v-model="selected.formulations"
					:loading="isLoading.formulations"
					class="c-input"
					@keydown.enter="selectOnEnter('formulations', $event)"
					ref="formulations"
					hide-details
					hide-selected
					cache-items
					:search-input.sync="search.formulations"
					:disabled="isLoading.search"
					@input="search.formulations = null"
				/>
			</v-col>

			<!-- Company -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Company"
					:items="companies"
					v-model="selected.companies"
					:loading="isLoading.companies"
					:search-input.sync="search.companies"
					hide-no-data
					hide-selected
					return-object
					class="c-input"
					@keydown.enter="selectOnEnter('companies', $event)"
					ref="companies"
					hide-details
					cache-items
					:disabled="isLoading.search"
					@input="search.companies = null"
				/>
			</v-col>

			<!-- Period -->
			<v-col>
				<v-select
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Period"
					:items="periods"
					v-model="selected.periods"
					class="c-input"
					return-object
					:disabled="isLoading.search"
					hide-details
					:menu-props="menuProps"
				/>
			</v-col>
		</v-row>

		<v-row>
			<!-- Region -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Region"
					:loading="isLoading.regions"
					:items="regions"
					v-model="selected.regions"
					return-object
					hide-details
					class="c-input"
					@change="handleOnChange('regions')"
					:search-input.sync="search.regions"
					:disabled="isLoading.search"
					@input="search.regions = null"
				/>
			</v-col>

			<!-- Substance -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Substance"
					:items="substances"
					v-model="selected.substances"
					:loading="isLoading.substances"
					:search-input.sync="search.substances"
					hide-no-data
					hide-selected
					return-object
					class="c-input"
					@keydown.enter="selectOnEnter('substances', $event)"
					ref="substances"
					hide-details
					cache-items
					@change="handleSubstances"
					:disabled="isLoading.search"
					@input="search.substances = null"
				/>
			</v-col>

			<!-- Strength -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Strength"
					:items="strengths"
					:loading="isLoading.strengths"
					v-model="selected.strengths"
					hide-selected
					return-object
					class="c-input"
					@keydown.enter="selectOnEnter('strengths', $event)"
					ref="strengths"
					hide-details
					cache-items
					:search-input.sync="search.strengths"
					:disabled="isLoading.search"
					@input="search.strengths = null"
				/>
			</v-col>

			<!-- Sales Channel -->
			<v-col>
				<v-select
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					:disabled="isLoading.search"
					label="Sales channel"
					:items="salesChannel"
					v-model="selected.salesChannel"
					@change="handleOnChange('salesChannel')"
					hide-details
					class="c-input"
					return-object
					:menu-props="menuProps"
				/>
			</v-col>

			<!-- Year -->
			<v-col>
				<v-select
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Year"
					:items="years"
					v-model="selected.years"
					class="c-input"
					hide-details
					:disabled="isLoading.search"
					return-object
					:menu-props="menuProps"
				/>
			</v-col>
		</v-row>

		<v-row>
			<!-- Brick -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Brick"
					:loading="isLoading.bricks"
					:items="bricks"
					v-model="selected.bricks"
					return-object
					class="c-input"
					hide-details
					@change="handleOnChange('bricks')"
					:search-input.sync="search.bricks"
					:disabled="isLoading.search"
					@input="search.bricks = null"
				/>
			</v-col>

			<!-- Product -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Product"
					:items="products"
					v-model="selected.products"
					:loading="isLoading.products"
					:search-input.sync="search.products"
					hide-no-data
					hide-selected
					return-object
					class="c-input"
					@keydown.enter="selectOnEnter('products', $event)"
					ref="products"
					hide-details
					cache-items
					:disabled="isLoading.search"
					@input="search.products = null"
				/>
			</v-col>

			<!-- VNR -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="VNR"
					:items="vnrs"
					v-model="selected.vnrs"
					:loading="isLoading.vnrs"
					:search-input.sync="search.vnrs"
					hide-no-data
					hide-selected
					return-object
					class="c-input"
					@keydown.enter="selectOnEnter('vnrs', $event)"
					ref="vnrs"
					hide-details
					cache-items
					:disabled="isLoading.search"
					@input="search.vnrs = null"
				/>
			</v-col>

			<!-- Measurement -->
			<v-col>
				<v-autocomplete
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					label="Measurement"
					:items="measurements"
					v-model="selected.measurements"
					class="c-input"
					@keydown.enter="selectOnEnter('measurements', $event)"
					ref="measurements"
					hide-details
					cache-items
					:search-input.sync="search.measurements"
					:disabled="isLoading.search"
					@input="search.measurements = null"
				/>
			</v-col>

			<!-- Month -->
			<v-col>
				<v-select
					chips
					clearable
					small-chips
					deletable-chips
					dense
					filled
					multiple
					:disabled="disableMonth || isLoading.search"
					label="Month"
					:items="months"
					v-model="selected.months"
					hide-details
					class="c-input"
					return-object
					:menu-props="menuProps"
				/>
			</v-col>
		</v-row>

		<!-- Buttons -->
		<v-row class="justify-end mb-2">
			<v-card-actions>
				<!-- Update saved search -->
				<div class="text-center" id="update">
					<v-btn
						v-if="item.content.editing"
						class="mr-3"
						color="primary"
						outlined
						:loading="isLoading.updateSavedSearch"
						:disabled="isLoading.search"
						@click="updateSavedSearch"
					>
						Save
						<v-icon right>mdi-content-save</v-icon>
					</v-btn>
				</div>

				<!-- Save search as -->
				<div class="text-center" id="save-as">
					<v-dialog v-model="dialogSaveSearchAs" width="500">
						<!-- Trigger "Save as" dialog -->
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								class="mr-3"
								color="primary"
								outlined
								v-if="item.content.editing"
								v-bind="attrs"
								v-on="on"
								:loading="isLoading.saveSearch"
								:disabled="isLoading.search"
							>
								Save as
								<v-icon right>mdi-content-save-edit</v-icon>
							</v-btn>
						</template>

						<v-card>
							<v-card-title class="primary white--text"
								>Save search as
								<v-spacer></v-spacer>
								<v-btn icon dark @click="dialogSaveSearchAs = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>

							<v-card-text class="mt-5">
								<v-form ref="saveSearchAsForm">
									<v-text-field
										label="Name"
										outlined
										v-model="saveSearchNameAs"
										@keydown.enter="saveSearchAs"
										:rules="[v => !!v || 'Name is required']"
										hide-details="auto"
									></v-text-field>
								</v-form>
							</v-card-text>

							<v-divider></v-divider>

							<v-card-actions>
								<v-spacer></v-spacer>

								<v-btn color="primary" text @click="saveSearchAs">Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</div>

				<!-- Save search -->
				<div class="text-center" id="save">
					<v-dialog v-model="dialogSaveSearch" width="500">
						<!-- Trigger "Save search" dialog -->
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								class="mr-3"
								color="primary"
								outlined
								v-if="!item.content.editing"
								v-bind="attrs"
								v-on="on"
								:loading="isLoading.saveSearch"
								:disabled="isLoading.search"
							>
								Save
								<v-icon right>mdi-content-save</v-icon>
							</v-btn>
						</template>

						<v-card>
							<v-card-title class="primary white--text"
								>Save search
								<v-spacer></v-spacer>
								<v-btn icon dark @click="dialogSaveSearch = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>

							<v-card-text class="mt-5">
								<v-form ref="saveSearchForm">
									<v-text-field
										label="Name"
										outlined
										v-model="saveSearchName"
										@keydown.enter="saveSearch"
										:rules="[v => !!v || 'Name is required']"
										hide-details="auto"
									></v-text-field>
								</v-form>
							</v-card-text>

							<v-divider></v-divider>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="primary" text @click="saveSearch">Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</div>

				<!-- Search -->
				<v-btn class="primary search-btn" @click="submitForm" :loading="isLoading.search">
					Search
					<v-icon right>mdi-magnify</v-icon>
				</v-btn>
			</v-card-actions>
		</v-row>
	</v-card>
</template>

<script>
	import CryptoJS from 'crypto-js';
	import Snackbar from './Snackbar.vue';
	import { eventBus } from '@/eventBus';
	import SearchAPI from '@/api/search.js';
	import GraphsAPI from '@/api/graphs.js';
	import PivotTable from './PivotTable.vue';
	import ArticleDataAPI from '@/api/articleData.js';
	import SavedSearchAPI from '@/api/savedSearch.js';

	/**
	 * @module SearchForm
	 *
	 * @vue-prop {object} item={} - The search form object
	 *
     * @vue-data {object} [snackbar={}] - Display message to user
	 * @vue-data {boolean} [snackbar.status=false] - Control whether to show/hide the snackbar 
	 * @vue-data {string} [snackbar.text=''] - Sets the snackbar message  
	 * @vue-data {string} [snackbar.color=''] - Sets the color of the snackbar
	 * @vue-data {string|number} [snackbar.timeout=-1] - Time to wait until snackbar hides, use -1 to keep open indefinitely
     * 
	 * @vue-data {object} [isLoading={}] - Display progress on buttons or forms
	 * @vue-data {boolean} [isLoading.countries=false] - Display progress for countries
	 * @vue-data {boolean} [isLoading.regions=false] - Display progress for regions
	 * @vue-data {boolean} [isLoading.bricks=false] - Display progress for bricks
	 * @vue-data {boolean} [isLoading.atcCodes=false] - Display progress for atc codes
	 * @vue-data {boolean} [isLoading.substances=false] - Display progress for substances
	 * @vue-data {boolean} [isLoading.products=false] - Display progress for products
	 * @vue-data {boolean} [isLoading.formulations=false] - Display progress for formulations
	 * @vue-data {boolean} [isLoading.strengths=false] - Display progress for strengths
	 * @vue-data {boolean} [isLoading.sizes=false] - Display progress for sizes
	 * @vue-data {boolean} [isLoading.vnrs=false] - Display progress for vnrs
	 * @vue-data {boolean} [isLoading.companies=false] - Display progress for companies
	 * @vue-data {boolean} [isLoading.updateSavedSearch=false] - Display progress for updating a saved search
	 * @vue-data {boolean} [isLoading.saveSearch=false] - Display progress for saving a search
	 * @vue-data {boolean} [isLoading.search=false] - Display progress for search
	 * @vue-data {boolean} [isLoading.pusher=false] - Display progress for Pusher
     * 
	 * @vue-data {array} [pivotData=[]] - Store pivot data
	 * @vue-data {array} [searchParams=[]] - Store search parameters
	 * @vue-data {boolean} [isSavedSearch=false] - Search form is coming from a saved search
	 * @vue-data {boolean} [disableMonth=false] - Disable month field
     * 
	 * @vue-data {boolean} [dialogUpdateSavedSearch=false] - Open/close dialog for updating a saved search
	 * @vue-data {boolean} [dialogSaveSearch=false] - Open/close dialog for saving a search
	 * @vue-data {boolean} [dialogSaveSearchAs=false] - Open/close dialog for saving a search as
     * 
	 * @vue-data {boolean} [saveSearchName=''] - Set saved search name
	 * @vue-data {boolean} [saveSearchNameAs=''] - Set saved search name as
     * 
	 * @vue-data {object} [search={}] - Set search input value
	 * @vue-data {string} [search.regions=null] - Search text input field for region
	 * @vue-data {string} [search.bricks=null] - Search text input field for brick
	 * @vue-data {string} [search.atcCodes=null] - Search text input field for atc code
	 * @vue-data {string} [search.substances=null] - Search text input field for substance
	 * @vue-data {string} [search.products=null] - Search text input field for product
	 * @vue-data {string} [search.formulations=null] - Search text input field for formulation
	 * @vue-data {string} [search.strengths=null] - Search text input field for strength
	 * @vue-data {string} [search.sizes=null] - Search text input field for size
	 * @vue-data {string} [search.vnrs=null] - Search text input field for vnr
	 * @vue-data {string} [search.companies=null] - Search text input field for company
	 * @vue-data {string} [search.measurements=null] - Search text input field for measurement
     * 
	 * @vue-data {object} [selected={}] - Store selected input values
	 * @vue-data {array} [selected.countries=[{ id: 0, text: 'All', disabled: false }]] - Store selected countries
	 * @vue-data {array} [selected.regions=[]] - Store selected regions
	 * @vue-data {array} [selected.bricks=[]] - Store selected bricks
	 * @vue-data {array} [selected.atcCodes=[]] - Store selected atc codes
	 * @vue-data {array} [selected.substances=[]] - Store selected substances
	 * @vue-data {array} [selected.products=[]] - Store selected products
	 * @vue-data {array} [selected.formulations=[]] - Store selected formulations
	 * @vue-data {array} [selected.strengths=[]] - Store selected strengths
	 * @vue-data {array} [selected.sizes=[]] - Store selected sizes
	 * @vue-data {array} [selected.salesChannel=[]] - Store selected sales channel
	 * @vue-data {array} [selected.vnrs=[]] - Store selected vnrs
	 * @vue-data {array} [selected.companies=[]] - Store selected companies
	 * @vue-data {array} [selected.measurements=[]] - Store selected measurements
	 * @vue-data {array} [selected.periods=[]] - Store selected periods
	 * @vue-data {array} [selected.years=[{ id: -1, text: 'Current year' }]] - Store selected years
	 * @vue-data {array} [selected.months=[{ id: 0, text: 'Previous month' }]] - Store selected months
     * 
	 * @vue-data {array} [countries=[]] - Store countries
	 * @vue-data {array} [regions=[]] - Store regions
	 * @vue-data {array} [bricks=[]] - Store bricks
	 * @vue-data {array} [atcCodes=[]] - Store atc codes
	 * @vue-data {array} [substances=[]] - Store substances
	 * @vue-data {array} [products=[]] - Store products
	 * @vue-data {array} [formulations=[]] - Store formulations
	 * @vue-data {array} [strengths=[]] - Store strengths
	 * @vue-data {array} [sizes=[]] - Store sizes
	 * @vue-data {array} [salesChannel=[{ id: 0, text: 'All', disabled: false }, { id: 'Hos', text: 'Hospital' }, { id: 'Pha', text: 'Pharmacy' }, { id: 'Vet', text: 'Veterinarian' }, { id: 'Other', text: 'Other' }]] - Store sales channel
	 * @vue-data {array} [vnrs=[]] - Store vnrs
	 * @vue-data {array} [companies=[]] - Store companies
	 * @vue-data {array} [measurements=['DDD', 'DDD MAT', 'DDD YTD', 'DDD MAT-1', 'DDD YTD-1', 'Qty', 'Qty MAT', 'Qty YTD', 'Qty MAT-1', 'Qty YTD-1', 'AIP', 'AUP', 'Value AIP', 'Value AIP MAT', 'Value AIP YTD', 'Value AIP MAT-1', 'Value AIP YTD-1', 'Value AUP', 'Value AUP MAT', 'Value AUP YTD', 'Value AUP MAT-1', 'Value AUP YTD-1', 'SO DDD', 'SO DDD MAT', 'SO DDD YTD', 'SO DDD MAT-1', 'SO DDD YTD-1', 'SO Qty', 'SO Qty MAT', 'SO Qty YTD', 'SO Qty MAT-1', 'SO Qty YTD-1', 'SO Value AIP', 'SO Value AIP MAT', 'SO Value AIP YTD', 'SO Value AIP MAT-1', 'SO Value AIP YTD-1', 'SO Value AUP', 'SO Value AUP MAT', 'SO Value AUP YTD', 'SO Value AUP MAT-1', 'SO Value AUP YTD-1']] - Store measurements
	 * @vue-data {array} [periods=[{ id: 1, text: 'MAT' }, { id: 2, text: 'MAT-1' }, { id: 3, text: 'YTD' }, { id: 4, text: 'YTD-1' }]] - Store periods
	 * @vue-data {array} [years=[{ id: -1, text: 'Current year' }, { id: 0, text: 'Previous year' }]] - Store years
	 * @vue-data {array} [months=[{ id: -1, text: 'Current month' }, { id: 0, text: 'Previous month' }, { id: 1, text: 'January' }, { id: 2, text: 'February' }, { id: 3, text: 'March' }, { id: 4, text: 'April' }, { id: 5, text: 'May' }, { id: 6, text: 'June' }, { id: 7, text: 'July' }, { id: 8, text: 'August' }, { id: 9, text: 'September' }, { id: 10, text: 'October' }, { id: 11, text: 'November' }, { id: 12, text: 'December' }]] - Store months
	 * 
     * @vue-data {object} [execOnce={}] - Functions to execute once
	 * @vue-data {boolean} [execOnce.countries=0] - Load countries once to prevent unnecessary calls
	 * @vue-data {boolean} [execOnce.regions=0] - Load regions once to prevent unnecessary calls
	 * @vue-data {boolean} [execOnce.bricks=0] - Load bricks once to prevent unnecessary calls
	 * 
     * @vue-data {array} [pivot_cols=[]] - Store pivot table columns
	 * @vue-data {array} [pivot_rows=[]] - Store pivot table rows
	 * 
     * @vue-data {object} pusher={} - Store Pusher data
	 * @vue-data {object} [menuProps={}] - Pass props to the v-menu component
	 * @vue-data {boolean} [menuProps.bottom=true] - Aligns the component towards the bottom
	 * @vue-data {boolean} [menuProps.offsetY=true] - Offset the menu on the y-axis. Works in conjunction with direction top/bottom
	 *
	 * @vue-event {object} pusher-event-{tabId} - Listen for emitted Pusher event that matches the tab ID
	 * @vue-event {object} set-pivot-cols-rows - Listen for emitted event to set pivot table columns/rows
	 * @vue-event {object} pivot-data - Emit data to pivot table
	 * @vue-event {object} pusher-event-status - Emit app-level message to user when search result is done
	 * @vue-event {event} get-pivot-cols-rows - Emit event to fetch current pivot table columns/rows
	 * @vue-event {event} update-saved-search - Emit event to SavedSearch component to re-render the datatable with the updated saved search
	 * @vue-event {event} save-search - Emit event to SavedSearch component to re-render the datatable with the newly created search
	 * @vue-event {event} close-sidebar - Emit event to close the sidebar
	 */
	export default {
		name: 'SearchForm',
		components: {
			Snackbar,
			PivotTable,
		},
		props: {
			item: {
				required: true,
				type: Object,
			},
		},
		data() {
			return {
				snackbar: {
					status: false,
					text: '',
					color: '',
					timeout: -1,
				},
				isLoading: {
					countries: false,
					regions: false,
					bricks: false,
					atcCodes: false,
					substances: false,
					products: false,
					formulations: false,
					strengths: false,
					sizes: false,
					vnrs: false,
					companies: false,
					updateSavedSearch: false,
					saveSearch: false,
					search: false,
					pusher: false,
				},
				pivotData: [],
				searchParams: [],
				isSavedSearch: false,
				disableMonth: false,
				dialogUpdateSavedSearch: false,
				dialogSaveSearch: false,
				saveSearchName: '',
				dialogSaveSearchAs: false,
				saveSearchNameAs: '',
				search: {
					regions: null,
					bricks: null,
					atcCodes: null,
					substances: null,
					products: null,
					formulations: null,
					strengths: null,
					sizes: null,
					vnrs: null,
					companies: null,
					measurements: null,
				},
				selected: {
					countries: [{ id: 0, text: 'All', disabled: false }],
					regions: [],
					bricks: [],
					atcCodes: [],
					substances: [],
					products: [],
					formulations: [],
					strengths: [],
					sizes: [],
					salesChannel: [],
					vnrs: [],
					companies: [],
					measurements: [],
					periods: [],
					years: [{ id: -1, text: 'Current year' }],
					months: [{ id: 0, text: 'Previous month' }],
				},
				countries: [],
				regions: [],
				bricks: [],
				atcCodes: [],
				substances: [],
				products: [],
				formulations: [],
				strengths: [],
				sizes: [],
				salesChannel: [
					{ id: 0, text: 'All', disabled: false },
					{ id: 'Hos', text: 'Hospital' },
					{ id: 'Pha', text: 'Pharmacy' },
					{ id: 'Vet', text: 'Veterinarian' },
					{ id: 'Other', text: 'Other' },
				],
				vnrs: [],
				companies: [],
				measurements: [
					'DDD',
					'DDD MAT',
					'DDD YTD',
					'DDD MAT-1',
					'DDD YTD-1',
					'Qty',
					'Qty MAT',
					'Qty YTD',
					'Qty MAT-1',
					'Qty YTD-1',
					'AIP',
					'AUP',
					'Value AIP',
					'Value AIP MAT',
					'Value AIP YTD',
					'Value AIP MAT-1',
					'Value AIP YTD-1',
					'Value AUP',
					'Value AUP MAT',
					'Value AUP YTD',
					'Value AUP MAT-1',
					'Value AUP YTD-1',
					'SO DDD',
					'SO DDD MAT',
					'SO DDD YTD',
					'SO DDD MAT-1',
					'SO DDD YTD-1',
					'SO Qty',
					'SO Qty MAT',
					'SO Qty YTD',
					'SO Qty MAT-1',
					'SO Qty YTD-1',
					'SO Value AIP',
					'SO Value AIP MAT',
					'SO Value AIP YTD',
					'SO Value AIP MAT-1',
					'SO Value AIP YTD-1',
					'SO Value AUP',
					'SO Value AUP MAT',
					'SO Value AUP YTD',
					'SO Value AUP MAT-1',
					'SO Value AUP YTD-1',
				],
				periods: [
					{ id: 1, text: 'MAT' },
					{ id: 2, text: 'MAT-1' },
					{ id: 3, text: 'YTD' },
					{ id: 4, text: 'YTD-1' },
				],
				years: [
					{ id: -1, text: 'Current year' },
					{ id: 0, text: 'Previous year' },
				],
				months: [
					{ id: -1, text: 'Current month' },
					{ id: 0, text: 'Previous month' },
					{ id: 1, text: 'January' },
					{ id: 2, text: 'February' },
					{ id: 3, text: 'March' },
					{ id: 4, text: 'April' },
					{ id: 5, text: 'May' },
					{ id: 6, text: 'June' },
					{ id: 7, text: 'July' },
					{ id: 8, text: 'August' },
					{ id: 9, text: 'September' },
					{ id: 10, text: 'October' },
					{ id: 11, text: 'November' },
					{ id: 12, text: 'December' },
				],
				execOnce: {
					countries: 0,
					regions: 0,
					bricks: 0,
				},
				pivot_cols: [],
				pivot_rows: [],
				pusher: {},
				menuProps: { bottom: true, offsetY: true },
			};
		},

		created() {
			// Listen for emitted data from "Search" view that has the matching tab ID
			eventBus.$on('pusher-event-' + this.item.tabId, payload => {
				this.pusher = payload;
			});

			eventBus.$on('set-pivot-cols-rows', payload => {
				const { pivot_cols, pivot_rows } = payload;

				this.pivot_cols = pivot_cols;
				this.pivot_rows = pivot_rows;
			});

			this.generateYears();

			// Get countries, regions & bricks from localStorage if they exist,
			// instead of making the same request whenever a new search tab is opened
			localStorage.getItem('countries') !== null
				? (this.countries = JSON.parse(localStorage.getItem('countries')))
				: this.loadCountries();

			localStorage.getItem('regions') !== null
				? (this.regions = JSON.parse(localStorage.getItem('regions')))
				: this.loadRegions(0);

			localStorage.getItem('bricks') !== null
				? (this.bricks = JSON.parse(localStorage.getItem('bricks')))
				: this.loadBricks(0, 0);
		},
		beforeDestroy() {
			// Remove listeners
			eventBus.$off('pusher-event-' + this.item.tabId);
			eventBus.$off('set-pivot-cols-rows');
		},
		mounted() {
			// Check if content is default or from saved search
			if (this.item.content.id !== 0) {
				// Set flag
				this.isSavedSearch = true;

				// Set default value to an array if property is undefined
				const {
					country = [],
					region = [],
					brick = [],

					atc_codes_h = [],
					product = [],

					formulation = [],
					strength = [],
					size = [],
					sales_channel_h = [],

					vnrs_h = [],
					company = [],
					measurement = [],

					period = [],
					year = [],
					month = [],
				} = this.item.content.search_params;

				// Since atc code and substance are the same we just inverse the key/value of atc code so we can use it as a substance
				let computedAtcCodes = [];
				let computedSubstances = [];

				if (atc_codes_h.length) {
					const substances = atc_codes_h.map(({ text, id }) => ({ id: [text], text: id }));

					const groupByText = substances.reduce((obj, { text, id }) => {
						obj[text] = obj[text] || [];
						obj[text].push(id);
						return obj;
					}, {});

					computedSubstances = Object.entries(groupByText).map(([text, id]) => ({ text, id: id.flat() }));

					computedAtcCodes = substances.flatMap(({ id, text }) => {
						return id.map(atcCode => ({ id: text, text: atcCode }));
					});
				}

				// Values need to be set before they can be selected
				this.atcCodes = computedAtcCodes;
				this.substances = computedSubstances;
				this.products = product;

				this.formulations = formulation;
				this.strengths = strength;
				this.sizes = size;

				this.vnrs = vnrs_h;
				this.companies = company;

				// Set selected values
				this.selected = {
					countries: country,
					regions: region,
					bricks: brick,

					atcCodes: computedAtcCodes,
					products: product,
					substances: computedSubstances,

					formulations: formulation,
					strengths: strength,
					sizes: size,
					salesChannel: sales_channel_h,

					vnrs: vnrs_h,
					companies: company,
					measurements: measurement,

					periods: period,
					years: year,
					months: month,
				};

				// If "search" is clicked in saved search, submit form
				if (this.item.content.searching) {
					this.submitForm();
				}

				// Check if "All" is selected as a country
				const allSelected = this.selected.countries.some(country => country.text === 'All');

				// If "All" is not selected as a country
				if (!allSelected) {
					// Find the index of value "All" and disable it
					const index = this.countries.findIndex(country => country.text === 'All');
					this.countries[index].disabled = true;
				}

				// This needs a better solution...
				// We don't want to trigger the watchers when fetching data from saved searches...
				setTimeout(() => {
					// Unset flag
					this.isSavedSearch = false;
				}, 1000);
			}
		},

		/**
		 * Listen for value changes in:
		 *
		 * - pusher
		 * - search.atcCodes
		 * - search.substances
		 * - search.vnrs
		 * - search.companies
		 * - search.products
		 * - selected.countries
		 * - selected.regions
		 * - selected.periods
		 * - selected.years
		 * - selected.atcCodes
		 * - selected.substances
		 * - selected.products
		 *
		 * @property {function} pusher - Handle Pusher
		 * @property {function} search.atcCodes - Load corresponding atc codes based on search input
		 * @property {function} search.substances - Load corresponding substances based on search input
		 * @property {function} search.vnrs - Load corresponding vnrs based on search input
		 * @property {function} search.companies - Load corresponding companies based on search input
		 * @property {function} search.products - Load corresponding products based on search input
		 * @property {function} selected.countries - Filter regions and bricks by selected country
		 * @property {function} selected.regions - Filter bricks by selected region
		 * @property {function} selected.periods - Clear selected years, months and disable month field if a period is selected
		 * @property {function} selected.years - Disable month field if no year is selected
		 * @property {function} selected.atcCodes - Load article data based on selected atc code
		 * @property {function} selected.substances - Clear article data
		 * @property {function} selected.products - Load article data based on selected product
		 */
		watch: {
			pusher: {
				handler: function(value) {
					// Check if Pusher is triggered
					if (this.isLoading.pusher) {
						// Reset snackbar status
						this.snackbar.status = false;

						// Get user ID from local storage
						const userID = localStorage.getItem('userID');

						// Parse decrypted string to integer
						const decryptedUserID = parseInt(
							CryptoJS.AES.decrypt(userID, process.env.VUE_APP_GOOGLE_SITE_KEY).toString(
								CryptoJS.enc.Utf8
							)
						);

						// Display data for correct user ID and tab ID
						if (value.user_id === decryptedUserID && value.stats_tab === this.item.tabId) {
							GraphsAPI.statsBricks(value.tbl)
								.then(({ data }) => {
									if (data.result === undefined || data.result.length === 0) {
										this.snackbar = {
											status: true,
											text: 'No results found.',
											color: 'error',
										};

										this.$emit('pivot-data', {
											tabId: this.item.tabId,
											pivotData: [],
										});
									} else {
										this.pivotData = data.result;

										this.$emit('pivot-data', {
											tabId: this.item.tabId,
											pivotData: this.pivotData,
											searchParams: this.selected,
										});

										// Emit app-level message to the user when the result is done
										eventBus.$emit('pusher-event-status', this.item);
									}
								})
								.catch(err => {
									console.error(err);

									this.snackbar = {
										status: true,
										text: 'Oops, something went wrong!',
										color: 'error',
									};
								})
								.finally(() => {
									this.isLoading.search = false;
									this.isLoading.pusher = false;
								});
						}
					}
				},
				deep: true,
				immediate: true,
			},
			'search.atcCodes': function(value) {
				this.loadAtcCodes(value);
			},

			'search.substances': function(value) {
				this.loadSubstances(value);
			},

			'search.vnrs': function(value) {
				this.loadVnrs(value);
			},

			'search.companies': function(value) {
				this.loadCompanies(value);
			},

			'search.products': function(value) {
				this.loadProducts(value);
			},

			'selected.countries': function(value) {
				// If a country is selected
				if (value && value.length) {
					if (!this.isSavedSearch) {
						// Clear selected region and brick
						this.selected.regions = [];
						this.selected.bricks = [];

						// Get country ID
						const countryID = value.map(country => country.id);

						// Load regions and bricks based on country ID
						this.loadRegions(countryID);
						this.loadBricks(countryID, 0);
					}
				} else {
					// If no country is selected, clear regions and bricks
					this.regions = [];
					this.bricks = [];
				}
			},

			'selected.regions': function(value) {
				// Get country ID
				const countryID = this.selected.countries.map(country => country.id);

				// If a region is selected
				if (value && value.length) {
					// Get region ID
					const regionID = value.map(region => region.id).join(',');

					// Load bricks based on country ID and region ID
					this.loadBricks(countryID, regionID);
				} else {
					// If no region is selected, reload bricks and clear selected bricks
					this.loadBricks(countryID, 0);
					this.selected.bricks = [];
				}
			},

			'selected.periods': function(value) {
				// If a period is selected
				if (value && value.length) {
					if (!this.isSavedSearch) {
						// Clear selected years, months and disable month field
						this.selected.years = [];
						this.selected.months = [];
						this.disableMonth = true;
					}
				}
			},

			'selected.years': function(value) {
				// If a year is selected
				if (value && value.length) {
					if (!this.isSavedSearch) {
						// Clear periods and disable month field
						this.selected.periods = [];
						this.disableMonth = false;
					}
				} else {
					// If no year is selected, clear selected months and disable month field
					this.selected.months = [];
					this.disableMonth = true;
				}
			},

			'selected.atcCodes': function(value) {
				// Load article data by ATC Code
				if (value && value.length) {
					this.loadArticleDataByAtcCodes(value);
				}

				// Clear corresponding article data
				this.clearArticleData(value);
			},

			'selected.substances': function(value) {
				this.clearArticleData(value);
			},

			'selected.products': function(value) {
				// Load article data by product
				if (value && value.length) {
					this.loadArticleDataByProducts(value);
				}

				// Clear corresponding article data
				this.clearArticleData(value);
			},
		},
		methods: {
			/**
			 * Generate years from 2015 to current year
			 */
			generateYears() {
				let max = new Date().getFullYear();
				let min = 2015;

				for (let i = max; i >= min; i--) {
					this.years.push({ id: i, text: i });
				}
			},

			/**
			 * Clear form and strength fields if selected substances, ATC Codes and products are empty
			 *
			 * @param {array} value - List with selected items
			 *
			 * @returns {void}
			 */
			clearArticleData(value) {
				if (value.length === 0 && this.selected.atcCodes.length === 0 && this.selected.products.length === 0) {
					this.$refs.formulations.cachedItems = [];
					this.$refs.strengths.cachedItems = [];

					this.formulations = [];
					this.strengths = [];
				}
			},

			/**
			 * @param {array<object>} value - List of selected atc codes
			 *
			 * @returns {void}
			 *
			 * @description
			 * A substance belongs to an ATC Code and vice versa
			 * <br>
			 * When an ATC Code gets selected, populate the substances that belongs to the selected ATC Codes
			 *
			 * - Check if the values are from a saved search
			 * - Prepare the formatted substances
			 * - Group substances
			 * - Populate substance field
			 */
			handleAtcCodes(value) {
				if (!this.isSavedSearch) {
					const computedSubstances = value.map(({ text, id }) => ({
						id: [text],
						text: id,
					}));

					const groupByText = computedSubstances.reduce((obj, { text, id }) => {
						obj[text] = obj[text] || [];
						obj[text].push(id);
						return obj;
					}, {});

					const result = Object.entries(groupByText).map(([text, id]) => ({
						text,
						id: id.flat(),
					}));

					this.substances.push(...result);
					this.selected.substances = result;
				}
			},

			/**
			 * @param {array<object>} value - List of selected substances
			 *
			 * @returns {void}
			 *
			 * @description
			 * An ATC code belongs to a substance and vice versa
			 * <br>
			 * When a substance gets selected, populate the ATC Codes that belongs to the selected substances
			 *
			 * - Check if the values are from a saved search
			 * - Prepare the formatted ATC Codes
			 * - Populate ATC Code field
			 */
			handleSubstances(value) {
				if (!this.isSavedSearch) {
					const computedAtcCodes = value.flatMap(({ id, text }) => {
						return id.map(atcCode => ({ id: text, text: atcCode }));
					});

					this.atcCodes.push(...computedAtcCodes);
					this.selected.atcCodes = computedAtcCodes;
				}
			},

			/**
			 * Handle value 'All' in dropdowns
			 */
			handleOnChange(value) {
				// If value exist
				if (value) {
					// Get id and index of value "All" since the index for it is not always at 0
					// and depends on which order it was selected
					const isValueAll = this.selected[value].some(el => el.id === 0);
					const indexOfValueAll = this.selected[value].findIndex(el => el.id === 0);

					// If the current selected value is empty
					if (this.selected[value].length === 0) {
						// Enable "All"
						// If value "All" is not selected,
						// indexOfValueAll will be undefined because that value doesn't exist
						if (this[value][indexOfValueAll] === undefined) {
							this[value][0].disabled = false;
						} else {
							this[value][indexOfValueAll].disabled = false;
						}
					}

					// If value is "All" and another value is selected, disable "All"
					// If value "All" is not selected,
					// indexOfValueAll will be undefined because that value doesn't exist
					if (isValueAll && this.selected[value].length > 1) {
						if (this[value][indexOfValueAll] === undefined) {
							this[value][0].disabled = true;
						} else {
							// Uncheck value "All" and disable it
							this.selected[value].splice(indexOfValueAll, 1);
							this[value][indexOfValueAll].disabled = true;
						}

						// If value is not "All" and another value is selected, disable "All"
					} else if (!isValueAll && this.selected[value].length) {
						this[value][0].disabled = true;
					}
				}
			},

			/**
			 * Populate field with the highlighted value on keypress enter
			 */
			selectOnEnter(value, event) {
				// Get highlighted list item
				const highlightedItem = document.querySelectorAll('.v-list-item--highlighted');

				// Select all on enter if the highlighted list is empty
				if (event.keyCode === 13 && highlightedItem.length === 0) {
					const filteredItems = this.$refs[value].filteredItems;

					// Return if filtered items is empty
					if (!filteredItems.length) return;

					// If array is empty
					if (!this.selected[value].length) {
						if (value === 'atcCodes') {
							this.handleAtcCodes(filteredItems);
						}

						if (value === 'substances') {
							this.handleSubstances(filteredItems);
						}

						// Set filtered items to selected values
						this.selected[value] = filteredItems;

						// If array is not empty
					} else {
						// Merge filtered items with the selected values and get only unique values
						const mergeUnique = [...new Set([].concat(this.selected[value], filteredItems))];

						if (value === 'atcCodes') {
							this.handleAtcCodes(mergeUnique);
						}

						if (value === 'substances') {
							this.handleSubstances(mergeUnique);
						}

						this.selected[value] = mergeUnique;
					}

					// Clear search input
					this.$refs[value].internalSearch = null;
				}
			},

			/*
                PUT    /api/v1/saved_search/{id}
            */

			/**
			 * @param {event} event - Listen for HTML DOM event
			 *
			 * @returns {void}
			 *
			 * @description
			 * Updates a saved search
			 *
			 * - Emit an event to fetch the columns/rows from the current pivot table
			 * - Display progress
			 * - Prepare the data we want to update
			 * <br>&nbsp;
			 * - @HTTP 200
			 * - Display success message
			 * - Emit an event to update the saved search datatable
			 * <br>&nbsp;
			 * - @HTTP 422
			 * - Display error message
			 */
			updateSavedSearch(event) {
				eventBus.$emit('get-pivot-cols-rows');
				this.isLoading.updateSavedSearch = true;

				const data = {
					search_name: this.item.content.search_name,
					search_params: {
						country: this.selected.countries,
						region: this.selected.regions,
						brick: this.selected.bricks,

						atc_codes_h: this.selected.atcCodes,
						product: this.selected.products,

						formulation: this.selected.formulations,
						strength: this.selected.strengths,
						size: this.selected.sizes,
						sales_channel_h: this.selected.salesChannel,

						vnrs_h: this.selected.vnrs,
						company: this.selected.companies,
						measurement: this.selected.measurements,

						period: this.selected.periods,
						year: this.selected.years,
						month: this.selected.months,

						pivot_cols: this.pivot_cols,
						pivot_rows: this.pivot_rows,
					},
				};

				SavedSearchAPI.update(data, this.item.content.id)
					.then(response => {
						if (response.status === 200) {
							this.snackbar = {
								status: true,
								text: response.data.text,
							};

							// Emit event to sibling component "SavedSearch" to trigger an update in the datatable
							eventBus.$emit('update-saved-search');
						}
					})
					.catch(error => {
						if (error.response.status === 422) {
							this.snackbar = {
								status: true,
								text: 'Oops, something went wrong!',
								color: 'error',
							};
						}

						console.error(error);
					})
					.finally(() => {
						if (event.keyCode === 13) {
							this.dialogUpdateSavedSearch = false;
						}

						this.isLoading.updateSavedSearch = false;

						setTimeout(() => {
							this.snackbar.status = false;
						}, 4000);
					});
			},

			/*
                POST        /api/v1/saved_search
            */

			/**
			 * @param {event} event - Listen for HTML DOM event
			 *
			 * @returns {void}
			 *
			 * @description
			 * Create a saved search
			 *
			 * - Emit an event to fetch the columns/rows from the current pivot table
			 * - Prepare the data we want to store
			 * - Validate form inputs
			 * <br>&nbsp;
			 * - @HTTP 200
			 * - Display success message
			 * - Emit an event to update the saved search datatable
			 * <br>&nbsp;
			 * - @HTTP 422
			 * - Display error message
			 */
			saveSearch(event) {
				// Emit event to fetch pivot cols & rows
				eventBus.$emit('get-pivot-cols-rows');

				// Data that we want to store
				const data = {
					search_name: this.saveSearchName,
					search_params: {
						country: this.selected.countries,
						region: this.selected.regions,
						brick: this.selected.bricks,

						atc_codes_h: this.selected.atcCodes,
						product: this.selected.products,

						formulation: this.selected.formulations,
						strength: this.selected.strengths,
						size: this.selected.sizes,
						sales_channel_h: this.selected.salesChannel,

						vnrs_h: this.selected.vnrs,
						company: this.selected.companies,
						measurement: this.selected.measurements,

						period: this.selected.periods,
						year: this.selected.years,
						month: this.selected.months,

						pivot_cols: this.pivot_cols,
						pivot_rows: this.pivot_rows,
					},
				};

				if (this.$refs.saveSearchForm.validate()) {
					this.dialogSaveSearch = false;
					this.$refs.saveSearchForm.reset();
					this.isLoading.saveSearch = true;

					SavedSearchAPI.store(data)
						.then(response => {
							if (response.status === 200) {
								this.snackbar = {
									status: true,
									text: response.data.text,
								};

								// Emit event to sibling component "SavedSearch" to trigger an update in the datatable
								eventBus.$emit('save-search');
							}
						})
						.catch(error => {
							if (error.response.status === 422) {
								this.snackbar = {
									status: true,
									text: error.response.data.errors.search_name[0],
									color: 'error',
								};
							} else {
								this.snackbar = {
									status: true,
									text: 'Oops, something went wrong!',
									color: 'error',
								};
							}

							console.error(error);
						})
						.finally(() => {
							if (event.keyCode === 13) {
								this.dialogSaveSearch = false;
							}

							this.isLoading.saveSearch = false;

							setTimeout(() => {
								this.snackbar.status = false;
							}, 4000);
						});
				}
			},

			/* 
                POST        /api/v1/saved_search
            */

			/**
			 * @param {event} event - Listen for HTML DOM event
			 *
			 * @returns {void}
			 *
			 * @description
			 * Save saved search as
			 *
			 * - Emit an event to fetch the columns/rows from the current pivot table
			 * - Prepare the data we want to store
			 * - Validate form inputs
			 * <br>&nbsp;
			 * - @HTTP 200
			 * - Display success message
			 * - Emit an event to update the saved search datatable
			 * <br>&nbsp;
			 * - @HTTP 422
			 * - Display error message
			 */
			saveSearchAs(event) {
				// Emit event to fetch pivot cols & rows
				eventBus.$emit('get-pivot-cols-rows');

				// Data that we want to store
				const data = {
					search_name: this.saveSearchNameAs,
					search_params: {
						country: this.selected.countries,
						region: this.selected.regions,
						brick: this.selected.bricks,

						atc_codes_h: this.selected.atcCodes,
						product: this.selected.products,

						formulation: this.selected.formulations,
						strength: this.selected.strengths,
						size: this.selected.sizes,
						sales_channel_h: this.selected.salesChannel,

						vnrs_h: this.selected.vnrs,
						company: this.selected.companies,
						measurement: this.selected.measurements,

						period: this.selected.periods,
						year: this.selected.years,
						month: this.selected.months,

						pivot_cols: this.pivot_cols,
						pivot_rows: this.pivot_rows,
					},
				};

				if (this.$refs.saveSearchAsForm.validate()) {
					this.dialogSaveSearchAs = false;
					this.$refs.saveSearchAsForm.reset();
					this.isLoading.saveSearch = true;

					SavedSearchAPI.store(data)
						.then(response => {
							if (response.status === 200) {
								this.snackbar = {
									status: true,
									text: response.data.text,
								};

								// Emit event to sibling component "SavedSearch" to trigger an update in the datatable
								eventBus.$emit('save-search');
							}
						})
						.catch(error => {
							if (error.response.status === 422) {
								this.snackbar = {
									status: true,
									text: error.response.data.errors.search_name[0],
									color: 'error',
								};
							} else {
								this.snackbar = {
									status: true,
									text: 'Oops, something went wrong!',
									color: 'error',
								};
							}

							console.error(error);
						})
						.finally(() => {
							if (event.keyCode === 13) {
								this.dialogSaveSearchAs = false;
							}

							this.isLoading.saveSearch = false;

							setTimeout(() => {
								this.snackbar.status = false;
							}, 4000);
						});
				}
			},

			/*
                POST    /api/v1/graph - Company ID !== 13
                POST    /api/v1/graph/gilead - Company ID === 13
            */

			/**
			 * @returns {void}
			 *
			 * @description
			 * Submits the search form
			 *
			 * - Display progress on button
			 * - Reset snackbar
			 * - Format and prepare the data we want to submit
			 * <br>&nbsp;
			 * - If response.data.scope !== false
			 * - Emit an event with a payload containing the pivot table data
			 * - If no result is found, display it to the user
			 * <br>&nbsp;
			 * - If response.data.scope === false
			 * - Trigger Pusher
			 * - Display 1st message to user
			 * - Display 2nd message after 26s
			 * - Display 3rd message after 46s
			 * - Once search result is done, emit an event with a payload containing the pivot table data
			 * - If no result is found, display it to the user
			 */
			submitForm() {
				this.isLoading.search = true;
				this.snackbar.status = false;

				// Get only unique values in array
				const uniqueArray = array => [...new Set(array)];

				// Get selected country id
				const country = this.selected.countries.map(country => country.id);

				const region = [],
					regions_h = [],
					brick = [];

				let bricks_h = [];

				// Get selected region id & text
				this.selected.regions.map(el => {
					region.push(el.id);
					regions_h.push(el.text);
				});

				// Get selected brick id & text
				this.selected.bricks.map(el => {
					if (el.id === 0) {
						brick.push(-1);
						bricks_h = [];
					} else {
						brick.push(el.id);
						bricks_h.push(el.text);
					}
				});

				// Get selected atc code text
				const atcCodeText = this.selected.atcCodes.map(atcCode => atcCode.text);

				// Get selected substance id
				const substanceId = this.selected.substances.flatMap(substance => substance.id);

				// Get selected product text
				const products_h = this.selected.products.map(product => product.text);

				// Get selected sales channel id
				const sales_channel_h = this.selected.salesChannel.map(channel => channel.id);

				// Get selected vnr id
				const vnrs_h = this.selected.vnrs.map(vnr => vnr.id);

				// Get selected company text
				const companies_h = this.selected.companies.map(company => company.text);

				// Get selected id for period, year & month
				const period = this.selected.periods.map(period => period.id);
				const year = this.selected.years.map(year => year.id);
				const month = this.selected.months.map(month => month.id);

				// Data that we want to send to the server
				const data = {
					tab: this.item.tabId,
					country: country,
					region: region,
					regions_h: regions_h,
					brick: uniqueArray(brick),
					bricks_h: bricks_h,

					atc_codes_h: uniqueArray(atcCodeText.concat(substanceId)),
					products_h: products_h,

					forms_h: this.selected.formulations,
					strengths_h: this.selected.strengths,
					sizes_h: this.selected.sizes,
					sales_channel_h: sales_channel_h,

					vnrs_h: vnrs_h,
					companies_h: companies_h,
					measurement: this.selected.measurements,

					period: period,
					year: year,
					month: month,

					pivot_cols: this.pivot_cols,
					pivot_rows: this.pivot_rows,
				};

				GraphsAPI.show(data)
					.then(({ data }) => {
						// Trigger BrickStats search
						if (data.scope === false) {
							this.isLoading.pusher = true;

							// First message
							this.snackbar = {
								status: true,
								text: 'Searching for data. Please wait...',
								timeout: 6000,
							};

							// Reset snackbar state
							setTimeout(() => {
								this.snackbar.status = false;
							}, 7000);

							// Second message after 26s
							setTimeout(() => {
								if (this.isLoading.pusher) {
									this.snackbar = {
										status: true,
										text:
											"Still searching for data.<div class='ml-6'>Seems like your dataset is quite large.</div><div class='ml-6'>It might take a while, please wait...</div>",
										timeout: 6000,
									};
								}
							}, 26000);

							// Reset snackbar state
							setTimeout(() => {
								this.snackbar.status = false;
							}, 33000);

							// Third message after 46s
							setTimeout(() => {
								if (this.isLoading.pusher) {
									this.snackbar = {
										status: true,
										text:
											"Your search is still running... <div class='ml-6'>Go and grab a cup of coffee!</div>",
										timeout: 6000,
									};
								}
							}, 46000);
						} else {
							// Emit pivot data to component "Search" to display the results
							if (data.result === undefined || data.result.length === 0) {
								this.snackbar = {
									status: true,
									text: 'No results found.',
									color: 'error',
								};

								this.$emit('pivot-data', {
									tabId: this.item.tabId,
									pivotData: [],
								});
							} else {
								this.pivotData = data.result;

								this.$emit('pivot-data', {
									tabId: this.item.tabId,
									pivotData: this.pivotData,
									searchParams: this.selected,
								});
							}
						}

						// Emit event to sibling component "Sidebar" to close the sidebar
						eventBus.$emit('close-sidebar');
					})
					.catch(error => {
						if (error) {
							this.snackbar = {
								status: true,
								text: 'Oops, something went wrong!',
								color: 'error',
							};
						}

						console.error(error);
					})
					.finally(() => {
						if (this.isLoading.pusher === false) {
							this.isLoading.search = false;

							setTimeout(() => {
								this.snackbar.status = false;
							}, 4000);
						}
					});
			},

			/*
                GET     /api/v1/article/atc_codes
            */

			/**
			 * @async
			 *
			 * @param {array<object>} value
			 *
			 * @returns {void}
			 *
			 * @description
			 * Load article data by selected ATC Codes
			 */
			async loadArticleDataByAtcCodes(value) {
				const atcCodes = value.map(item => item.text);

				this.isLoading.formulations = true;
				this.isLoading.strengths = true;
				// this.isLoading.sizes = true;

				try {
					const { data } = await ArticleDataAPI.getByAtcCodes(atcCodes);

					const form = data.filter(item => item.form !== null).map(item => item.form);
					const strength = data.filter(item => item.strength !== null).map(item => item.strength);
					// const size = data.filter((item) => item.size !== null).map((item) => item.size);

					this.formulations = form;
					this.strengths = strength;
					// this.sizes = size;
				} catch (error) {
					console.error(error);
				} finally {
					this.isLoading.formulations = false;
					this.isLoading.strengths = false;
					// this.isLoading.sizes = false;
				}
			},

			/*
                GET     /api/v1/article/products
            */

			/**
			 * @async
			 *
			 * @param {array<object>} value
			 *
			 * @returns {void}
			 *
			 * @description
			 * Load article data by selected products
			 */
			async loadArticleDataByProducts(value) {
				const products = value.map(item => item.text);

				this.isLoading.formulations = true;
				this.isLoading.strengths = true;
				// this.isLoading.sizes = true;

				ArticleDataAPI.getByProducts(products)
					.then(({ data }) => {
						if (data) {
							const uniqueFormulations = [
								...new Set(data.filter(item => item.form !== null).map(item => item.form)),
							];
							const uniqueStrengths = [
								...new Set(data.filter(item => item.strength !== null).map(item => item.strength)),
							];
							// const uniqueSizes = [
							//     ...new Set(data.filter((item) => item.size !== null).map((item) => item.size)),
							// ];

							this.formulations = uniqueFormulations;
							this.strengths = uniqueStrengths;
							// this.sizes = uniqueSizes;
						}
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => {
						this.isLoading.formulations = false;
						this.isLoading.strengths = false;
						// this.isLoading.sizes = false;
					});
			},

			/*
                GET     /api/v1/search/countries
            */

			/**
			 * @async
			 *
			 * @returns {void}
			 *
			 * @description
			 * Load countries based on company ID
			 *
			 * - Set countries to local storage
			 * - If the same request is made, get data from local storage instead of making unnecessary calls
			 */
			async loadCountries() {
				try {
					this.isLoading.countries = true;

					const { data } = await SearchAPI.getCountries();
					this.countries = data.countries.map(country => Object.assign(country, { disabled: false }));
					this.execOnce.countries++;

					if (this.execOnce.countries === 1) {
						localStorage.setItem('countries', JSON.stringify(this.countries));
					}
				} catch (error) {
					console.error(error);
				} finally {
					this.isLoading.countries = false;
				}
			},

			/*
                GET     /api/v1/search/regions/{country_id}
            */

			/**
			 * @async
			 *
			 * @param {number|string} countryId - The country ID
			 *
			 * @returns {void}
			 *
			 * @description
			 * Load regions based on country ID
			 *
			 * - Set regions to local storage
			 * - If the same request is made, get data from local storage instead of making unnecessary calls
			 */
			async loadRegions(countryId) {
				try {
					this.isLoading.regions = true;

					const { data } = await SearchAPI.getRegions(countryId);
					this.regions = data.regions;
					this.execOnce.regions++;

					if (this.execOnce.regions === 1) {
						localStorage.setItem('regions', JSON.stringify(this.regions));
					}
				} catch (error) {
					console.error(error);
				} finally {
					this.isLoading.regions = false;
				}
			},

			/*
                GET     /api/v1/search/bricks/countries/{country}/regions/{region}
            */

			/**
			 * @async
			 *
			 * @param {number|string} countryId - The country ID
			 * @param {number|string} regionID - The region ID
			 *
			 * @returns {void}
			 *
			 * @description
			 * Load bricks based on country ID and region ID
			 *
			 * - Set bricks to local storage
			 * - If the same request is made, get data from local storage instead of making unnecessary calls
			 */
			async loadBricks(countryId, regionId) {
				try {
					this.isLoading.bricks = true;

					const { data } = await SearchAPI.getBricks(countryId, regionId);
					this.bricks = data.bricks;
					this.execOnce.bricks++;

					if (this.execOnce.bricks === 1) {
						localStorage.setItem('bricks', JSON.stringify(this.bricks));
					}
				} catch (error) {
					console.error(error);
				} finally {
					this.isLoading.bricks = false;
				}
			},

			/*
                GET     /api/v1/search/atc_codes/{atc_code}
            */

			/**
			 * @param {string} value - Text input for ATC code field 
			 *
			 * @returns {void}
			 *
			 * @description
			 * Filter ATC Codes based on text input
			 */
			loadAtcCodes(value) {
				if (value === null) return;
				// Items have already been loaded
				if (value !== null && value.length < 3) return;

				// Items have already been requested
				if (this.isLoading.atcCodes) return;

				this.isLoading.atcCodes = true;

				SearchAPI.getAtcCodes(value)
					.then(response => {
						this.atcCodes = response.data;
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => (this.isLoading.atcCodes = false));
			},

			/*
                GET     /api/v1/search/substances/{substance}
            */

			/**
			 * @param {string} value - Text input for substance field 
			 *
			 * @returns {void}
			 *
			 * @description
			 * Filter substances based on text input
			 */
			loadSubstances(value) {
				if (value === null) return;
				// Items have already been loaded
				if (value !== null && value.length < 3) return;

				// Items have already been requested
				if (this.isLoading.substances) return;

				this.isLoading.substances = true;

				SearchAPI.getSubstances(value)
					.then(response => {
						this.substances = response.data;
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => (this.isLoading.substances = false));
			},

			/*
                GET     /api/v1/search/products/{product}
            */

			/**
			 * @param {string} value - Text input for product field 
			 *
			 * @returns {void}
			 *
			 * @description
			 * Filter products based on text input
			 */
			loadProducts(value) {
				if (value === null) return;
				// Items have already been loaded
				if (value !== null && value.length < 3) return;

				// Items have already been requested
				if (this.isLoading.products) return;

				this.isLoading.products = true;

				SearchAPI.getProducts(value)
					.then(response => {
						this.products = response.data;
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => (this.isLoading.products = false));
			},

			/*
                GET     /api/v1/search/vnrs/{vnr}
            */

			/**
			 * @param {string} value - Text input for vnr field 
			 *
			 * @returns {void}
			 *
			 * @description
			 * Filter vnrs based on text input
			 */
			loadVnrs(value) {
				if (value === null) return;
				// Items have already been loaded
				if (value !== null && value.length < 3) return;

				// Items have already been requested
				if (this.isLoading.vnrs) return;

				this.isLoading.vnrs = true;

				SearchAPI.getVnrs(value)
					.then(response => {
						this.vnrs = response.data;
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => (this.isLoading.vnrs = false));
			},

			/*
                GET     /api/v1/search/companies/{company}
            */

			/**
			 * @param {string} value - Text input for company field
			 *
			 * @returns {void}
			 *
			 * @description
			 * Filter companies based on text input
			 */
			loadCompanies(value) {
				if (value === null) return;
				// Items have already been loaded
				if (value !== null && value.length < 3) return;

				// Items have already been requested
				if (this.isLoading.companies) return;

				this.isLoading.companies = true;

				SearchAPI.getCompanies(value)
					.then(response => {
						this.companies = response.data;
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => (this.isLoading.companies = false));
			},
		},
	};
</script>

<style lang="scss">
	.search-btn {
		padding-left: 16px !important;
	}

	.c-input {
		border-radius: 4px !important;

		/* Hide bottom border */
		& ::before {
			border: none !important;
		}

		& .v-select__slot {
			margin-bottom: 4px;
		}

		/* Size of 'remove all selected values' icon */
		& .v-icon.notranslate.v-icon--link.mdi.mdi-close.theme--light {
			font-size: 1rem;
		}

		/* Set margin on the first chip */
		& .v-chip--select:nth-of-type(1) {
			margin-top: 4px !important;
		}

		& .v-chip--select {
			margin-bottom: 4px !important;
		}
	}
</style>
